 <!-- error-403 start-->
 <div class="error-wrapper">
    <div class="container"><img class="img-100" src="assets/images/other-images/sad.png" alt="">
      <div class="error-heading">
        <h2 class="headline font-success">403</h2>
      </div>
      <div class="col-md-8 offset-md-2">
          <p>Un courriel de vérification vous a été envoyé à l'adresse suivante :</p>
          <p style="font-weight: bold;">Votre adresse courriel : </p>
          <p>Veuillez cliquer sur le lien de vérification contenu dans ce courriel pour activer votre compte.</p>
      </div>
      <div><a class="btn btn-success-gradien btn-lg" routerLink=''>BACK TO HOME PAGE</a></div>
    </div>
  </div>
  <!-- error-403 end-->
